import { ApiHandler } from '../api-handler';
import { ApiEndpoints, HttpMethod } from '../constants';
import {
  BLQuestionsApiResponse,
  SpecialtiesApiResponse,
  StatesApiResponse,
  RegionsApiResponse,
  PmsNamesApiResponse,
  SecureMessagingProvidersApiResponse,
} from '../user/types';

export const ReferenceApiService = {
  getSpecialties: () =>
    ApiHandler.makeApiRequest<SpecialtiesApiResponse>({
      endpoint: ApiEndpoints.Reference.Specialties,
      rejectOnError: true,
      method: HttpMethod.Get,
    }),

  getBlQuestions: (subSpecialtyId: string) =>
    ApiHandler.makeApiRequest<BLQuestionsApiResponse>({
      endpoint: ApiEndpoints.Reference.BLQuestions(subSpecialtyId),
      method: HttpMethod.Get,
    }),

  getFocusAreas: (subSpecialtyId: string) =>
    ApiHandler.makeApiRequest<BLQuestionsApiResponse>({
      endpoint: ApiEndpoints.Reference.FocusAreas(subSpecialtyId),
      method: HttpMethod.Get,
    }),

  getStates: (country?: string) =>
    ApiHandler.makeApiRequest<StatesApiResponse>({
      endpoint: ApiEndpoints.Reference.States,
      rejectOnError: true,
      method: HttpMethod.Get,
      withAuth: false,
      ...(country ? { query: { country } } : {}),
    }),

  getRegions: () =>
    ApiHandler.makeApiRequest<RegionsApiResponse>({
      endpoint: ApiEndpoints.Reference.Regions,
      rejectOnError: true,
      method: HttpMethod.Get,
      withAuth: false,
    }),

  getPmses: (country?: string) =>
    ApiHandler.makeApiRequest<PmsNamesApiResponse>({
      endpoint: ApiEndpoints.Reference.Pmses,
      rejectOnError: true,
      method: HttpMethod.Get,
      withAuth: false,
      ...(country ? { query: { country } } : {}),
    }),

  getSecureMessagingProviders: () =>
    ApiHandler.makeApiRequest<SecureMessagingProvidersApiResponse>({
      endpoint: ApiEndpoints.Reference.SecureMessagingProviders,
      rejectOnError: true,
      method: HttpMethod.Get,
      withAuth: false,
    }),
} as const;
